module.exports = __webpack_public_path__ + "static/img/img9.595ef27a.png";